import React, { useState } from "react";
import { Button, ButtonGroup, NavLink } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "../../styles/buttons.scss";
import Tooltip from "./Tooltip.js";
import { Dropdown } from "react-bootstrap";

// export const TitleButton = () => {
//   return (
//     <div>
//       <Tooltip content="Start Free Trial" direction="bottom">
//         <Button className="trial">
//           Start Free Trial<br></br>
//           <p className="subtitle">No Credit Card Required</p>
//         </Button>
//       </Tooltip>
//     </div>
//   );
// };

export const TitleButton = () => {
  const [data, setdata] = useState(false);
  const opencard = () => {
    setdata(true);
  };
  const closecard = () => {
    setdata(false);
  };
  return (
    <div>
      <Dropdown className="titleDropdown1" show={data} onClick={opencard}>
        <Dropdown.Toggle className="trial">
          Start Free Trial<br></br>
          <span className="subtitle">No Credit Card Required </span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdownOption" onMouseLeave={closecard}>
          <span className="dropdown-menu-arrow"></span>
          <Dropdown.Item
            href="https://app.cloudsocial.io/accounts/gold/9"
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-card-item"
          >
            Brand
          </Dropdown.Item>
          <Dropdown.Item
            href="https://app.cloudsocial.io/accounts/platinum/17"
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-card-item"
          >
            Agency
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export const TrialButtons = () => {
  return (
    <div>
      <Tooltip content="Start Free Trial" direction="bottom">
        <LinkContainer to="/pricing">
          <Button className="trial">
            Start Free Trial<br></br>
            <p className="trial-subtitle">No Credit Card Required</p>
          </Button>
        </LinkContainer>
      </Tooltip>
    </div>
  );
};

// export const TrialButton = () => {
//   return (
//     <div>
//       <Tooltip content="Start Free Trial" direction="bottom">
//         <LinkContainer to="/pricing">
//           <Button className="trialButton">
//             Start Free Trial<br></br>
//             <p className="trial-subtitle">No Credit Card Required</p>
//           </Button>
//         </LinkContainer>
//       </Tooltip>
//     </div>
//   );
// };
export const TrialButton = () => {
  const [data, setdata] = useState(false);
  const opencard = () => {
    setdata(true);
  };
  const closecard = () => {
    setdata(false);
  };
  return (
    <div>
      <Dropdown className="" show={data} onClick={opencard}>
        <Dropdown.Toggle className="trialButton">
          Start Free Trial
          <p className="trial-subtitle">No Credit Card Required</p>
        </Dropdown.Toggle>
        <Dropdown.Menu
          className="dropdownOption dropdownResource"
          onMouseLeave={closecard}
        >
          <span className="dropdown-menu-arrow"></span>
          <Dropdown.Item
            href="https://app.cloudsocial.io/accounts/gold/9"
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-card-item"
          >
            Brand
          </Dropdown.Item>
          <Dropdown.Item
            href="https://app.cloudsocial.io/accounts/platinum/17"
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-card-item"
          >
            Agency
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

// export const TrialButton = () => {
//   return (
//     <div>
//       <Tooltip content="Start Free Trial" direction="top">
//         <Button
//           style={{
//             alignItems: "center",
//             alignContent: "center",
//           }}
//           className="start mt-5 mb-5"
//         >
//           Start Free Trial
//         </Button>
//       </Tooltip>

//       <ButtonGroup>
//         <LinkContainer to="/pricing">
//           <NavLink>
//             <Button to="/pricing" className="btn">
//               Start Scheduling Now
//             </Button>
//             <Button className="btn">Start Free Trial</Button>
//           </NavLink>
//         </LinkContainer>
//       </ButtonGroup>
//     </div>
//   );
// };

export const SilverPayButton = () => {
  return (
    <div>
      <a
        href="https://app.cloudsocial.io/accounts/silver/5"
        target="_blank"
        rel="noopener noreferrer"
        //className="design"
      >
        {/* <Tooltip content="Start Free Trial" direction="top"> */}
        <Button className="PayButton">Start free trial</Button>
        {/* </Tooltip> */}
      </a>
    </div>
  );
};
export const GoldPayButton = () => {
  return (
    <div>
      <a
        href="https://app.cloudsocial.io/accounts/gold/9"
        target="_blank"
        rel="noopener noreferrer"
        //className="design"
      >
        {/* <Tooltip content="Start Free Trial" direction="top"> */}
        <Button className="PayButton">Start free trial</Button>
        {/* </Tooltip> */}
      </a>
    </div>
  );
};
export const PlatinumPayButton = () => {
  return (
    <div>
      <a
        href="https://app.cloudsocial.io/accounts/platinum/17"
        target="_blank"
        rel="noopener noreferrer"
        //className="design"
      >
        {/* <Tooltip content="Start Free Trial" direction="top"> */}
        <Button className="PayButton">Start free trial</Button>
        {/* </Tooltip> */}
      </a>
    </div>
  );
};

export const SilverButton = () => {
  return (
    <div className="dataLogin">
      <a
        href="https://app.cloudsocial.io/accounts/silver/5"
        target="_blank"
        rel="noopener noreferrer"
        // className="design "
      >
        <Button
          className="silverButton"
          style={{ backgroundColor: "white !important" }}
        >
          Start free trial
        </Button>
      </a>
    </div>
  );
};
export const GoldButton = () => {
  return (
    <div className="dataLogin">
      <a
        href="https://app.cloudsocial.io/accounts/gold/9"
        target="_blank"
        rel="noopener noreferrer"
        // className="design "
      >
        <Button className="Signup">Start free trial</Button>
      </a>
    </div>
  );
};
export const PlatinumButton = () => {
  return (
    <div className="dataLogin">
      <a
        href="https://app.cloudsocial.io/accounts/platinum/17"
        target="_blank"
        rel="noopener noreferrer"
        // className="design "
      >
        <Button className="silverButton">Start free trial</Button>
      </a>
    </div>
  );
};

// export const SignUps = () => {
//   return (
//     <div className="dataLogin">
//       <a
//         href="https://app.cloudsocial.io/accounts/platinum/17"
//         target="_blank"
//         rel="noopener noreferrer"
//         // className="design "
//       >
//         <Button className="sign">Start free trial</Button>
//       </a>
//     </div>
//   );
// };

export const MenuButton = () => {
  const [data, setdata] = useState(false);
  const opencard = () => {
    setdata(true);
  };
  const closecard = () => {
    setdata(false);
  };

  // const [data, setdata] = useState(false);
  // const opencard = () => {
  //   setdata(true);
  // };
  // const closecard = () => {
  //   setdata(false);
  // };
  return (
    <div>
      <Dropdown className="" show={data} onClick={opencard}>
        <Dropdown.Toggle className="login">Login</Dropdown.Toggle>
        <Dropdown.Menu
          className="dropdown-card login-card"
          onMouseLeave={closecard}
        >
          <span className="dropdown-menu-arrow"></span>
          <Dropdown.Item
            href="https://app.cloudsocial.io/accounts/login"
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-card-items"
          >
            CloudSocial
          </Dropdown.Item>
          {/* <Dropdown.Item
            href="https://ciapp.cloudsocial.io/account/login"
            className="dropdown-card-items"
            target="_blank"
            rel="noopener noreferrer"
          >
            CloudInsights
          </Dropdown.Item> */}
          {/* <Dropdown.Item href="#/action-3" className="dropdown-card-item">
            CloudStream
          </Dropdown.Item> */}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
// export const MenuButton = () => {
//   const [data, setdata] = useState(false);
//   const opencard = () => {
//     setdata(true);
//   };
//   const closecard = () => {
//     setdata(false);
//   };
//   return (
//     <div>
//       <Dropdown className="" show={data} onMouseEnter={opencard}>
//         <Dropdown.Toggle className="login">Login</Dropdown.Toggle>
//         <Dropdown.Menu className="dropdown-card" onMouseLeave={closecard}>
//           <span className="dropdown-menu-arrow"></span>
//           <Dropdown.Item
//             href="https://app.cloudsocial.io/accounts/Login"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="dropdown-card-item"
//           >
//             CloudSocial
//           </Dropdown.Item>
//           <Dropdown.Item
//             href="https://ciapp.cloudsocial.io/account/login"
//             className="dropdown-card-item"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             CloudInsight
//           </Dropdown.Item>
//         </Dropdown.Menu>
//       </Dropdown>
//     </div>
//   );
// };

export const MenuButton1 = () => {
  return (
    <div className="dataLogin">
      <a
        href="https://app.cloudsocial.io/accounts/Login"
        target="_blank"
        rel="noopener noreferrer"
        className="login "
      >
        <Button className="login" style={{ boxShadow: "none" }}>
          Login
        </Button>
      </a>
    </div>
  );
};
